export enum SlideVariation {
  ImageLeft = 'ImageLeft',
  ImageRight = 'ImageRight',
}
